// extracted by mini-css-extract-plugin
export default {"infoIconContainer":"InfoButtonModal_infoIconContainer__IaFtq","button":"InfoButtonModal_button__ayQgA"};